import { http } from '@kunlun/dependencies';

export const queryCancelReasonApi = async () => {
  const gql = `
    query {
      deliAriesSellerOrderCancelReasonQuery {
        queryPage(
          page: { currentPage: 1, size: 100 }
          queryWrapper: { rsql: "1==1" }
        ) {
          content {
            id
            cancelReason
          }
          size
          totalPages
          totalElements
        }
      }
    }
  `;
  const res = await http.query('deliAriesCoreSeller', gql);
  return res?.data?.deliAriesSellerOrderCancelReasonQuery?.queryPage ?? {};
};

export const closeOrderPart = async (formData: Record<any, any>) => {
  // const gql = `
  //   mutation {
  //     deliAriesOrderPartCancelParamMutation {
  //       closeOrderPart(
  //         data: {
  //           orderCode: "T2312200187645"
  //           buyerName: "喜洋洋"
  //           createOrderSaleSkuList: [
  //             {
  //               tradeOrderDetailId: 553332770031380984
  //               outCode: "100002862"
  //               itemName: "得力6600ES中性笔0.5mm子弹头(黑)(支)"
  //               itemCode: "10000286201S18002"
  //               itemNum: 1
  //               deliveredNum: 0
  //               undeliveredNum: 1
  //               applyCloseNum: 0
  //               deliAriesSellerOrderCancelReason: {
  //                 id: 556443537534719616
  //                 cancelReason: "测试"
  //               }
  //             }
  //           ]
  //           orderId: 553332770031380983
  //         }
  //       ) {
  //         orderCode
  //         buyerName
  //         createOrderSaleSkuList {
  //           tradeOrderDetailId
  //           outCode
  //           itemName
  //           itemCode
  //           itemNum
  //           tmsOrderNum
  //           deliveredNum
  //           undeliveredNum
  //           applyCloseNum
  //           deliAriesSellerOrderCancelReason {
  //             id
  //             cancelReason
  //           }
  //           id
  //         }
  //         orderId
  //       }
  //     }
  //   }
  // `;
  // const res = await http.query('deliAriesCoreSeller', gql);
  // return res?.data?.deliAriesOrderPartCancelParamMutation?.closeOrderPart ?? {};
};
